import { useCallback } from 'react';
import { analytics } from '../lib/analytics/service';

export function useAnalytics() {
  const trackWaitlistJoin = useCallback((country: string) => {
    analytics.trackWaitlistJoin(country);
  }, []);

  const trackQuestionView = useCallback((questionId: string, category: string) => {
    analytics.trackQuestionView(questionId, category);
  }, []);

  const trackQuestionVote = useCallback((questionId: string) => {
    analytics.trackQuestionVote(questionId);
  }, []);

  const trackCategoryFilter = useCallback((category: string) => {
    analytics.trackCategoryFilter(category);
  }, []);

  return {
    trackWaitlistJoin,
    trackQuestionView,
    trackQuestionVote,
    trackCategoryFilter
  };
}